/**
 * Locale bundles of the admin-mirroring Manager modules (one folder per group, FLAT `adminmod_<group>_*` keys).
 * Explicit requires (Metro cannot resolve dynamic paths); merged into the single `translation` namespace by i18n.js.
 */
import {getLinkedinNetworkLocale} from '../linkedinNetwork';
import {getLinkedinCampaignsLocale} from '../linkedinCampaigns';
import {getLinkedinPostToolsLocale} from '../linkedinPostTools';
import {getLinkedinAnalyticsLocale} from '../linkedinAnalytics';

const BUNDLES = {
    hu: () => ({
        ...require('./crm/hu.json'),
        ...require('./warehouse/hu.json'),
        ...require('./marketing/hu.json'),
        ...require('./hr/hu.json'),
        ...require('./system/hu.json'),
        ...require('./service/hu.json'),
        ...require('./finance/hu.json'),
        ...require('./settings/hu.json'),
        ...require('./developer/hu.json'),
        ...require('./users/hu.json'),
        ...require('./storecfg/hu.json'),
        ...require('./extras1/hu.json'),
        ...require('./extras2/hu.json'),
        ...require('./extras3/hu.json'),
    }),
    en: () => ({
        ...require('./crm/en.json'),
        ...require('./warehouse/en.json'),
        ...require('./marketing/en.json'),
        ...require('./hr/en.json'),
        ...require('./system/en.json'),
        ...require('./service/en.json'),
        ...require('./finance/en.json'),
        ...require('./settings/en.json'),
        ...require('./developer/en.json'),
        ...require('./users/en.json'),
        ...require('./storecfg/en.json'),
        ...require('./extras1/en.json'),
        ...require('./extras2/en.json'),
        ...require('./extras3/en.json'),
    }),
    de: () => ({
        ...require('./crm/de.json'),
        ...require('./warehouse/de.json'),
        ...require('./marketing/de.json'),
        ...require('./hr/de.json'),
        ...require('./system/de.json'),
        ...require('./service/de.json'),
        ...require('./finance/de.json'),
        ...require('./settings/de.json'),
        ...require('./developer/de.json'),
        ...require('./users/de.json'),
        ...require('./storecfg/de.json'),
        ...require('./extras1/de.json'),
        ...require('./extras2/de.json'),
        ...require('./extras3/de.json'),
    }),
    ro: () => ({
        ...require('./crm/ro.json'),
        ...require('./warehouse/ro.json'),
        ...require('./marketing/ro.json'),
        ...require('./hr/ro.json'),
        ...require('./system/ro.json'),
        ...require('./service/ro.json'),
        ...require('./finance/ro.json'),
        ...require('./settings/ro.json'),
        ...require('./developer/ro.json'),
        ...require('./users/ro.json'),
        ...require('./storecfg/ro.json'),
        ...require('./extras1/ro.json'),
        ...require('./extras2/ro.json'),
        ...require('./extras3/ro.json'),
    }),
    cn: () => ({
        ...require('./crm/cn.json'),
        ...require('./warehouse/cn.json'),
        ...require('./marketing/cn.json'),
        ...require('./hr/cn.json'),
        ...require('./system/cn.json'),
        ...require('./service/cn.json'),
        ...require('./finance/cn.json'),
        ...require('./settings/cn.json'),
        ...require('./developer/cn.json'),
        ...require('./users/cn.json'),
        ...require('./storecfg/cn.json'),
        ...require('./extras1/cn.json'),
        ...require('./extras2/cn.json'),
        ...require('./extras3/cn.json'),
    }),
    svn: () => ({
        ...require('./crm/svn.json'),
        ...require('./warehouse/svn.json'),
        ...require('./marketing/svn.json'),
        ...require('./hr/svn.json'),
        ...require('./system/svn.json'),
        ...require('./service/svn.json'),
        ...require('./finance/svn.json'),
        ...require('./settings/svn.json'),
        ...require('./developer/svn.json'),
        ...require('./users/svn.json'),
        ...require('./storecfg/svn.json'),
        ...require('./extras1/svn.json'),
        ...require('./extras2/svn.json'),
        ...require('./extras3/svn.json'),
    }),
};

/**
 * @param {string} lng Language code (hu|en|de|ro|cn|svn).
 * @returns {object} Merged admin-module keys for the language ({} when unknown).
 */
export const getAdminModulesLocale = (lng) => ({...(BUNDLES[lng] ? BUNDLES[lng]() : {}), ...getLinkedinNetworkLocale(lng), ...getLinkedinCampaignsLocale(lng), ...getLinkedinPostToolsLocale(lng), ...getLinkedinAnalyticsLocale(lng)});

export default getAdminModulesLocale;
